import { Howl, Howler } from 'howler'
import anime from 'animejs'
import values from 'lodash/values'
import sortBy from 'lodash/sortBy'
// import bgMp3 from '@/assets/sound/grok.mp3'
// import clickMp3 from '@/assets/sound/click-bright.mp3'
let hidden
let visibilityChange
if (typeof document.hidden !== 'undefined') { // Opera 12.10 and Firefox 18 and later support
  hidden = 'hidden'
  visibilityChange = 'visibilitychange'
} else if (typeof document.msHidden !== 'undefined') {
  hidden = 'msHidden'
  visibilityChange = 'msvisibilitychange'
} else if (typeof document.webkitHidden !== 'undefined') {
  hidden = 'webkitHidden'
  visibilityChange = 'webkitvisibilitychange'
}
class SoundManager {
  constructor () {
    this.fullVolume = 1
    this.volume = this.fullVolume
    // this.isMuted = false
    // this.isUserMuted = false

    this.muteStatus = {
      user: { priority: 4, muted: false },
      route: { priority: 3, muted: false },
      content: { priority: 2, muted: false },
      visibility: { priority: 1, muted: false }
    }
  }

  initialize ({ clickSound, bgSound }) {
    document.addEventListener(visibilityChange, this.handleVisibilityChange.bind(this), false)

    this.click = new Howl({
      src: [clickSound],
      volume: 0.7
    })
    this.bg = new Howl({
      src: [bgSound],
      volume: 0.4,
      loop: true
    })

    this.bg.play()
  }

  handleVisibilityChange () {
    if (document[hidden]) {
      // console.log('visibility hidden, muting')
      this.mute('visibility', true)
    } else {
      this.unmute('visibility')
    }
  }

  // canMute (priority) {
  //   // const stack = sortBy(values(this.muteStatus), ['priority'])
  //   // for (let i = 0; i < stack.length; i++) {
  //   //   if (stack[i].muted) return false
  //   // }
  //   return true
  // }

  canUnMute (priority) {
    const stack = sortBy(values(this.muteStatus), ['priority'])
    for (let i = 0; i < stack.length; i++) {
      if (stack[i].muted) return false
    }
    return true
  }

  mute (initiator, abrupt = false) {
    this.muteStatus[initiator].muted = true
    // if (!this.canMute()) return

    // if (userInitiated && this.isUserMuted) return
    // else if (!userInitiated && this.isMuted) return
    // // we let both users and system mute audio (automatically)
    // this.isMuted = true
    // this.isUserMuted = userInitiated

    anime.remove(this)
    if (abrupt) {
      Howler.volume(0)
    } else {
      anime({
        targets: [this],
        volume: 0,
        easing: 'linear',
        duration: 1000,
        update: (anim) => {
          Howler.volume(this.volume)
        }
      })
    }
  }

  // if (!this.isMuted) return
  unmute (initiator) {
    this.muteStatus[initiator].muted = false

    if (!this.canUnMute(this.muteStatus[initiator].priority)) return
    // ignore unmute if user has muted before and system is trying to unmute (automatically)
    // if (this.isUserMuted && !userInitiated) return

    // if (userInitiated && this.isMuted) { this.isMuted = false }
    // if (userInitiated) {
    //   this.isUserMuted = false
    // }
    anime.remove(this)
    anime({
      targets: [this],
      volume: this.fullVolume,
      easing: 'linear',
      duration: 1000,
      update: (anim) => {
        Howler.volume(this.volume)
      }
    })
  }

  playClick () {
    if (!this.isMuted) this.click.play()
  }
}

export default new SoundManager()
